$(document).ready(function(){

  // Search - mobile
  // --------------------
  /** 
  $('.header__search-toggle').on('click', function(e) {
    $('.header__search').toggleClass('mobile-show');
  });

  $('.header__search, .header__search-toggle').click(function(e){
    e.stopPropagation()
  });

  $('body').on('click', function() {
    if ($('.header__search').hasClass('mobile-show')) {
      $('.header__search').removeClass('mobile-show');
    }
  })
*/
  // Drawer Menu - mobile
  // --------------------
  $('[data-drawer]').on('click', function(e) {
    e.preventDefault();

    const body = $('html, body');
    const nav = $('.cycheader-nav-container');

    if (nav.hasClass('active')) {
      body.removeClass('drawer-active')
      nav.removeClass('active');
    } else {
      body.addClass('drawer-active')
      nav.addClass('active');
    };
  });

  $('[data-nav="top-item"].has-menu').on('click', function(e) {
    if ($(window).width() < 991) {
      e.preventDefault();
      const item = $(this).closest('.item-main')

      if (item.hasClass('active')) {
        item.removeClass('active');
      } else {
        item.addClass('active');
      };
    };
  });

  $('.link-block-title.has-children a').on('click', function(e) {
    if ($(window).width() < 991) {
      e.preventDefault();
      const item = $(this).closest('.menu-column')

      if (item.hasClass('active')) {
        item.removeClass('active');
      } else {
        item.addClass('active');
      };
    };
  });

  $('.link-block-title.empty-space').each(function(i, v) {
    const colWrapper = $(this).closest('.menu-column-wrapper')
    const thisMenuCol = $(this).closest('.menu-column')
    const firstMenuCol = colWrapper.find('.menu-column:first')
    const closestTitle = thisMenuCol.prevAll('.has-title:first')

    if (closestTitle.length > 0) {
      $(this).next().clone().addClass('clone').appendTo(closestTitle)
    } else {
      $(this).next().clone().addClass('clone').appendTo(firstMenuCol)
      firstMenuCol.addClass('show')
      firstMenuCol.find('ul.clone').addClass('show')
    }
  });
});
if ($(window).width() > 990) {
$(".item-main").mouseover(function() {
  $(".cycoverlay").css({
  'opacity': '1',
  'visibility': 'visible'
  });
});
$(".item-main").mouseout(function() {
  $(".cycoverlay").css({
  'opacity': '0',
  'visibility': 'hidden'
  });
});
$(".cycmainmenucontainer").mouseout(function() {
  $(".cycoverlay").css({
  'opacity': '0',
  'visibility': 'hidden'
  });
});
$(".cycoverlay").click(function() {
  $(".cycoverlay").css({
  'opacity': '0',
  'visibility': 'hidden'
  });
});
}
